export default {


  aboutIranPhoenix: "About Iran Phoenix",

  aboutDescription: `Language-Kid is a team of English language specialists who have been working professionally with children and teenagers for many years. With nearly 20 years of teaching experience, the team has authored and translated around 30 language-learning books and has also achieved valuable international recognition. Under the supervision of Mr. Mohammad Khaled Feizi, the team has won gold medals and certificates of appreciation at international festivals in Canada, Romania, Poland, Malaysia, Lebanon, and Japan for developing innovative language-learning methods for children. Today, the team is proud to serve the children of our beloved Iran with a wealth of experience and achievements.`,

  variousGames: "A Variety of Games",
  learningPracticeEntertainment: "Learning, practice, and entertainment in one unique experience",

  educationalVideos: "Educational Videos",
  learningWithVideos: "Learn English through engaging and practical videos",

  audioFiles: "Audio Files",
  listeningSkills: "Improve listening skills with engaging and practical audio content",

};
